import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { of, throwError } from 'rxjs';
import { concatMap, delay, retryWhen } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../../../@fuse/components/progress-bar/progress-bar.service";
export var retryCount = 3;
export var retryWaitMilliSeconds = 3000;
var ServerErrorInterceptor = /** @class */ (function () {
    function ServerErrorInterceptor(progressBar) {
        this.progressBar = progressBar;
    }
    ServerErrorInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        return next.handle(request).pipe(retryWhen(function (requestError) {
            return requestError.pipe(concatMap(function (error, count) {
                if (count <= retryCount && isServerErrorStatus(error.status)) {
                    return of(error);
                }
                _this.progressBar.hide();
                return throwError(error);
            }), delay(retryWaitMilliSeconds));
        }));
    };
    ServerErrorInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ServerErrorInterceptor_Factory() { return new ServerErrorInterceptor(i0.ɵɵinject(i1.FuseProgressBarService)); }, token: ServerErrorInterceptor, providedIn: "root" });
    return ServerErrorInterceptor;
}());
export { ServerErrorInterceptor };
function isServerErrorStatus(status) {
    return status === 0 || status === 503 || status === 504;
}
